import React, { useState, useEffect } from "react";
import { Dialog } from "@material-ui/core";
import { Shimmer, Image } from "react-shimmer";
import { AiFillCloseCircle } from "react-icons/ai";

import "./index.css";
import { api_call } from "../../utils/Network";
import { isMobiledevice } from "../../utils/helperFunctions";

const wdth = window.innerWidth;

export default function GalleryView() {
  const [displayData, setDisplayData] = useState([]);
  const [imageView, setImageView] = useState("");

  useEffect(() => {
    api_call
      .get(`service_list/gallery?size=20`)
      .then((response) => {
        const data = response.data.data;
        if (data?.length) {
          data.map((d) => {
            const img = new Image();
            img.src = d.file1;
          });
          setTimeout(() => setDisplayData(data), 1200);
        }
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  }, []);

  const imageType = (url = "", type = "ls") => {
    return (
      <Image
        src={url}
        NativeImgProps={{
          style: {
            width: "100%",
            height: "100%",
            objectFit: "fill",
            cursor: "zoom-in",
          },
          onClick: () => setImageView(url),
        }}
        fallback={
          <Shimmer
            height={window.innerWidth < 770 ? 50 : 120}
            width={window.innerWidth < 770 ? 50 : 120}
          />
        }
      />
    );
  };

  console.log(displayData, "DisplayData")

  return (
    <div
      style={{
        padding: "3%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {displayData.length ? (
        <div class="angry-grid">
          <div id="item-0">{imageType(displayData[0]?.file1)}</div>
          <div id="item-1">{imageType(displayData[1]?.file1)}</div>
          <div id="item-2">{imageType(displayData[2]?.file1, "sq")}</div>
          <div id="item-3">{imageType(displayData[3]?.file1)}</div>
          <div id="item-4">{imageType(displayData[4]?.file1, "pt")}</div>
          <div id="item-5">{imageType(displayData[5]?.file1, "pt")}</div>
          <div id="item-6">{imageType(displayData[6]?.file1, "sq")}</div>
          <div id="item-7">{imageType(displayData[7]?.file1, "sq")}</div>
          <div id="item-8">{imageType(displayData[8]?.file1, "sq")}</div>
          <div id="item-9">{imageType(displayData[9]?.file1)}</div>
          <div id="item-10">{imageType(displayData[10]?.file1, "sq")}</div>
          <div id="item-11">{imageType(displayData[11]?.file1, "pt")}</div>
          <div id="item-12">{imageType(displayData[12]?.file1)}</div>
          <div id="item-13">{imageType(displayData[13]?.file1)}</div>
          <div id="item-14">{imageType(displayData[14]?.file1, "sq")}</div>
          <div id="item-15">{imageType(displayData[15]?.file1)}</div>
          <div id="item-16">{imageType(displayData[16]?.file1, "sq")}</div>
        </div>
      ) : (
        <Shimmer
          height={window.innerWidth < 770 ? 300 : 600}
          width={window.innerWidth < 770 ? 300 : 600}
        />
      )}
      {imageView.length > 0 && (
        <Dialog
          fullScreen
          open
          onClose={() => setImageView("")}
          PaperProps={{ style: { background: "transparent" } }}
          // TransitionComponent
        >
          <div
            style={{
              textAlign: "right",
              fontSize: 30,
              position: "absolute",
              top: "2%",
              right: "3%",
              cursor: "pointer",
              zIndex: 99,
              color: "#fff",
            }}
          >
            <AiFillCloseCircle onClick={() => setImageView("")} />
          </div>
          {imageView?.includes(";###") ? (
            <video
              src={imageView?.split(";###")[0]}
              autoPlay
              muted
              style={{ objectFit: "contain", width: "100%", height: "100%" }}
              onClick={() => setImageView("")}
            />
          ) : (
            <Image
              src={imageView}
              NativeImgProps={{
                style: {
                  width: "100%",
                  objectFit: "contain",
                  height: "100vh",
                  cursor: "zoom-out",
                },
                onClick: () => setImageView(""),
              }}
              fallback={<Shimmer width={400} height={500} />}
            />
          )}
        </Dialog>
      )}
    </div>
  );
}